import { editPassword } from '@/apis/edit-password';
import { EDIT_PASSWORD } from '../mutation-types';

export const state = {
  editPassword: '',
  alert: false,
};

export const getters = {
  alert: (state) => state.alert,
};

export const mutations = {
  [EDIT_PASSWORD.EDIT_PASSWORD](state, data) {
    state.editPassword = data;
  },
  [EDIT_PASSWORD.ALERT_EDIT_PASSWORD_CHANGE](state, data) {
    state.alert = !state.alert;
  },
};

export const actions = {
  async editPassword({ commit }, data) {
    const res = await editPassword(data);
    if (res) {
      return res;
    }
    commit(EDIT_PASSWORD.EDIT_PASSWORD, res);
    return false;
  },
  async alertBankAccount({ commit }) {
    commit(EDIT_PASSWORD.ALERT_EDIT_PASSWORD_CHANGE);
  },
};
